import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} width="16" height="16" viewBox="0.321 0.356 15.289 15.289">
    <path
      paintOrder="stroke fill markers"
      fillRule="evenodd"
      d="M7.966.356l3.172 3.172-7.644 7.644L.32 8v7.644h7.645l-3.173-3.172 7.645-7.644L15.61 8V.356H7.966z"
    />
  </SvgIcon>
);

export default Icon;
